import { useContext } from 'react';
import DropdownContext from './DropdownContext';
import DropdownInnerContext from './DropdownInnerContext';

/**
 * @ignore - Do not document.
 */
export default function useDropdownContext() {
  const generalContext = useContext(DropdownContext);
  const innerContext = useContext(DropdownInnerContext);
  return Object.assign({}, innerContext, generalContext);
}